'use client';

import type { ReactNode } from 'react';
import { cn } from '@/libs/utils';

interface DrawerWhyProps {
  title?: string;
  body: ReactNode;
}

interface DrawerCTAProps {
  label: string;
  onClick?: () => void;
  variant?: 'black' | 'blue';
}

export const DEFAULT_DRAWER_WHY_BODY: ReactNode = (
  <>
    You build trust with us through your <strong>on-time payments</strong>. We
    reward you by letting you pick up future items before you finish paying.
  </>
);

/**
 * Back-compat alias. Keep until call sites migrate to DEFAULT_DRAWER_WHY_BODY.
 */
export const DEFAULT_DRAWER_WHY_COPY = DEFAULT_DRAWER_WHY_BODY;

export function DrawerWhy({
  title = 'Why we work this way',
  body,
}: DrawerWhyProps) {
  return (
    <div className="flex flex-col gap-1 pt-3">
      <p className="text-[13px] font-extrabold text-[#0C0C0C]">{title}</p>
      <p className="text-[12px] font-medium leading-[1.5] text-[#475569]">
        {body}
      </p>
    </div>
  );
}

/**
 * Primary footer CTA. Defaults to black acknowledgement; use 'blue' for
 * conversion / money actions (Shop, Make payment).
 */
export function DrawerCTA({
  label,
  onClick,
  variant = 'black',
}: DrawerCTAProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full rounded-[10px] px-4 py-3.5 text-[14px] font-bold text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-motitoBlue focus-visible:ring-offset-2',
        variant === 'black' ? 'bg-[#0C0C0C]' : 'bg-motitoBlue'
      )}
    >
      {label}
    </button>
  );
}
